import produce from "immer"

export const actionTypes = {
  uploadSecureCaptureSelfie: "uploadSecureCaptureSelfie",
  uploadSecureCaptureSelfieCompleted: "uploadSecureCaptureSelfieCompleted",
  uploadSecureCaptureSelfieFailed: "uploadSecureCaptureSelfieFailed",
  onTrySecureCaptureSelfieAgainClicked: "onTrySecureCaptureSelfieAgainClicked",
  unexpectedErrorTryAgainClicked: "unexpectedErrorTryAgainClicked",
  onFaceDetectionTextChanged: "onFaceDetectionTextChanged",
  faceHintShown: "faceHintShown",
  perfectHintShown: "perfectHintShown",
  manualCaptureSelected: "manualCaptureSelected",
  autoCaptureSelected: "autoCaptureSelected",
}

export const actionFactory = {
  uploadSecureCaptureSelfie: payload => ({type: actionTypes.uploadSecureCaptureSelfie, payload}),
  uploadSecureCaptureSelfieCompleted: payload => ({type: actionTypes.uploadSecureCaptureSelfieCompleted, payload}),
  uploadSecureCaptureSelfieFailed: payload => ({type: actionTypes.uploadSecureCaptureSelfieFailed, payload}),
  onTrySecureCaptureSelfieAgainClicked: () => ({type: actionTypes.onTrySecureCaptureSelfieAgainClicked}),
  unexpectedErrorTryAgainClicked: () => ({type: actionTypes.unexpectedErrorTryAgainClicked}),
  onFaceDetectionTextChanged: payload => ({type: actionTypes.onFaceDetectionTextChanged, payload}),
  faceHintShown: () => ({type: actionTypes.faceHintShown}),
  perfectHintShown: () => ({type: actionTypes.perfectHintShown}),
  manualCaptureSelected: payload => ({type: actionTypes.manualCaptureSelected, payload}),
  autoCaptureSelected: () => ({type: actionTypes.autoCaptureSelected}),
}

// No-op when the camera never opened: that try is not counted as an attempt.
export const finaliseAttempt = (draft, outcome) => {
  const current = draft.identityState.currentAttempt
  if (!current || !current.cameraOpenedAt) return

  draft.identityState.attempts = draft.identityState.attempts || []
  draft.identityState.attempts.push({
    attemptNumber: current.attemptNumber,
    faceHintCount: current.faceHintCount,
    perfectHintCount: current.perfectHintCount,
    durationMs: new Date().getTime() - current.cameraOpenedAt,
    outcome
  })
  draft.identityState.currentAttempt = undefined
}

export const identityReducer = (state, action) => produce(state, draft => {
  const {type, payload} = action

  switch (type) {
    case actionTypes.uploadSecureCaptureSelfie:
      draft.identityState.uploadSecureCaptureSelfieInProgress = true
      draft.identityState.uploadSecureCaptureSelfieFailed = undefined
      draft.timingMap[actionTypes.uploadSecureCaptureSelfie] = new Date().getTime()
      break

    case actionTypes.uploadSecureCaptureSelfieCompleted:
      draft.identityState.uploadSecureCaptureSelfieCompleted = true
      draft.identityState.uploadSecureCaptureSelfieFailed = undefined
      draft.identityState.uploadSecureCaptureSelfieInProgress = false
      draft.timingMap[actionTypes.uploadSecureCaptureSelfieCompleted] = new Date().getTime()
      finaliseAttempt(draft, "success")
      break

    case actionTypes.uploadSecureCaptureSelfieFailed:
      draft.identityState.uploadSecureCaptureSelfieCompleted = undefined
      draft.identityState.uploadSecureCaptureSelfieFailed = payload
      draft.identityState.uploadSecureCaptureSelfieInProgress = false
      finaliseAttempt(draft, "upload_failed")
      break

    case actionTypes.onTrySecureCaptureSelfieAgainClicked:
      draft.identityState.uploadSecureCaptureSelfieCompleted = undefined
      draft.identityState.uploadSecureCaptureSelfieFailed = undefined
      draft.identityState.faceDetectionErrorCodes = []
      break

    case actionTypes.onFaceDetectionTextChanged:
      draft.identityState.faceDetectionErrorCodes = payload
      break

    case actionTypes.faceHintShown:
      draft.identityState.faceHintCount = (draft.identityState.faceHintCount || 0) + 1
      if (draft.identityState.currentAttempt) {
        draft.identityState.currentAttempt.faceHintCount += 1
      }
      break

    case actionTypes.perfectHintShown:
      draft.identityState.perfectHintCount = (draft.identityState.perfectHintCount || 0) + 1
      if (draft.identityState.currentAttempt) {
        draft.identityState.currentAttempt.perfectHintCount += 1
      }
      break

    case actionTypes.manualCaptureSelected:
      draft.identityState.useManualCapture = true
      draft.identityState.faceDetection = undefined
      draft.cameraInitializationTimedOut = undefined
      break

    case actionTypes.autoCaptureSelected:
      draft.identityState.useManualCapture = false
      draft.identityState.faceDetection = undefined
      draft.cameraInitializationTimedOut = undefined
      break

    default:
    // do nothing for now
  }
})

